import { WidgetSize, WidgetType } from '../Widget/widget.types';
export const layoutBreakpoints = { lg: 1440, md: 1024, sm: 960, xs: 640, xxs: 0 };
export const layoutColumns = { lg: 6, md: 4, sm: 3, xs: 2, xxs: 1 };
const widthMap = {
    [WidgetSize.XS]: 1,
    [WidgetSize.S]: 2,
    [WidgetSize.L]: 3,
};
const inventoryHeightMap = {
    [WidgetSize.XS]: 2,
    [WidgetSize.S]: 2,
    [WidgetSize.L]: 2,
};
const deviationHeightMap = {
    [WidgetSize.XS]: 2,
    [WidgetSize.S]: 2,
    [WidgetSize.L]: 2,
};
const getWidgetWidth = (widget) => {
    var _a;
    switch (widget.type) {
        case WidgetType.INVENTORY:
        case WidgetType.LOAD_DEVIATION:
        case WidgetType.DELIVER_DEVIATION:
            return widthMap[((_a = widget.config) === null || _a === void 0 ? void 0 : _a.size) || WidgetSize.XS];
        default:
            return widget.w;
    }
};
const getWidgetHeight = (widget) => {
    var _a, _b;
    switch (widget.type) {
        case WidgetType.INVENTORY:
            return inventoryHeightMap[((_a = widget.config) === null || _a === void 0 ? void 0 : _a.size) || WidgetSize.XS];
        case WidgetType.LOAD_DEVIATION:
        case WidgetType.DELIVER_DEVIATION:
            return deviationHeightMap[((_b = widget.config) === null || _b === void 0 ? void 0 : _b.size) || WidgetSize.XS];
        default:
            return widget.h;
    }
};
export const generateLayout = (widgets) => {
    const layout = widgets === null || widgets === void 0 ? void 0 : widgets.map((widget) => ({
        i: widget.uuid,
        x: widget.x,
        y: widget.y,
        w: getWidgetWidth(widget),
        h: getWidgetHeight(widget),
    }));
    return { lg: layout, md: layout, sm: layout, xs: layout, xxs: layout };
};
//# sourceMappingURL=widgetGridLayout.js.map